export default __webpack_public_path__ + "static/media/XLMUSD.db9e96ee.svg";